import Model from './Model';

export default class Bonus extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'bonuses';
  }
}
